
<template>
  <div class="navbar">
    <Hamburger
      id="hamburger-container"
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggle-click="toggleSideBar"
    />
    <refresh :isActive="active" class="hamburger-container refresh" @pageRefresh="onRefresh" />
    <!-- <BreadCrumb
      id="breadcrumb-container"
      class="breadcrumb-container"
    /> -->
    <div class="right-menu">
      <template v-if="device !== 'mobile'">
        <!-- <error-log class="errLog-container right-menu-item hover-effect" /> -->
        <!-- <Screenfull class="right-menu-item hover-effect" /> -->
        <!-- <el-tooltip
          :content="t('navbar.size')"
          effect="dark"
          placement="bottom"
        >
          <SizeSelect class="right-menu-item hover-effect" />
        </el-tooltip> -->
        <div class="setrightmenu">
        <el-dropdown>
      <span class="laguaes">
       <img src="../../../assets/images/public/language.png" alt="">
      </span>
      <template #dropdown>
        <el-dropdown-menu>
          <el-dropdown-item @click="setlaguase('en')">English</el-dropdown-item>
          <el-dropdown-item @click="setlaguase('zh-cn')">简体中文</el-dropdown-item>
          <el-dropdown-item @click="setlaguase('ko')">한국어</el-dropdown-item>
          <el-dropdown-item @click="setlaguase('de')">Deutsch</el-dropdown-item>
          <el-dropdown-item @click="setlaguase('fr')">Français</el-dropdown-item>
          <el-dropdown-item @click="setlaguase('ja')">日本語</el-dropdown-item>
          <el-dropdown-item @click="setlaguase('nl')">Dutch</el-dropdown-item>
          <el-dropdown-item @click="setlaguase('pl')">Polski</el-dropdown-item>
        </el-dropdown-menu>
      </template>
    </el-dropdown>
           <headPortrait @signOutLogin="loginOut" class="right-menu-item hover-effect" />
        </div>
      </template>
      <el-dropdown
        class="avatar-container right-menu-item hover-effect"
        trigger="click" 
        v-if="false"
      >
        <div class="avatar-wrapper">
          <img
            :src="user.avatar + '?imageView2/1/w/80/h/80'"
            class="user-avatar"
          >
          <span>{{ user.name }}</span>
        </div>
        <template #dropdown>
          <el-dropdown-menu>
            <!-- <router-link to="/set/systemSet">
              <el-dropdown-item>
                {{ t("route.systemSet") }}
              </el-dropdown-item>
            </router-link> -->
            <el-dropdown-item
              @click="logout"
            >
              <span style="display:block;">
                {{ t("navbar.logOut") }}
              </span>
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
      <dailogs :dialogVisibles="dialogFlag" :title="tle" :msg="tip" :btnFlag="true" @off="OFF" @on="ON"></dailogs>
    </div>
  </div>
</template>

<script>
// import BreadCrumb from '@/components/bread-crumb/Index.vue'
import Hamburger from '@/components/hamburger/Index.vue'
import Screenfull from '@/components/screenfull/Index.vue'
import headPortrait from '@/components/headPortrait/Index.vue'
import refresh from '@/components/refresh/index.vue'
import dailogs from '@/components/dialogs/dialogs.vue'

// import SizeSelect from '@/components/size_select/Index.vue'

import { computed, reactive, toRefs,inject } from 'vue'
import { useStore } from '@/store'
import { AppActionTypes } from '@/store/modules/app/action-types'
import { useI18n } from 'vue-i18n'
import { UserActionTypes } from '@/store/modules/user/action-types'
import { useRoute, useRouter } from 'vue-router'
import { removeToken } from '@/utils/cookies'
export default {
  components: {
    // BreadCrumb,
    Hamburger,
    Screenfull,
    headPortrait,
    refresh,
    dailogs
    // SizeSelect
  },
  setup() {
    const store = useStore()
    const route = useRoute()
    const router = useRouter()
    const reloads = inject('reload')
    const { t,locale } = useI18n()
    const sidebar = computed(() => {
      return store.state.app.sidebar
    })
    const device = computed(() => {
      return store.state.app.device.toString()
    })
    const user = computed(() => {
      return store.state.user
    })
    const state = reactive({
      tle: t('navigationBar.logout'),
      tip: t('navigationBar.logoutandsystem'),
      active: false,
      dialogFlag: false,
      toggleSideBar: () => {
        store.dispatch(AppActionTypes.ACTION_TOGGLE_SIDEBAR, false)
      },
      onRefresh(){
        state.active = true
        window.location.reload()
      },
      logout: () => {
        useStore().dispatch(UserActionTypes.ACTION_LOGIN_OUT)
        router.push(`/login?redirect=${route.fullPath}`).catch(err => {
          console.warn(err)
        })
      }
    })
     function setlaguase(lang) {
           console.log(lang)
           store.dispatch(AppActionTypes.ACTION_SET_LANGUAGE, lang)
          //  console.log(locale)
           location.reload()
          //  locale.value = lang
          // reloads()
     }
     function loginOut(val){
      console.log('asduuiqw',val)
      if(val == true){
        ON()
      }else {
        state.dialogFlag = true
      }
        
      }
      function OFF(){
        state.dialogFlag = false
      }
      function ON(){
        state.dialogFlag = false
        useStore().dispatch(UserActionTypes.ACTION_LOGIN_OUT)
        router.push('/login').catch(err => {
          console.warn('ssssssssssssssss',err)
        })
        console.log('执行了')
      }
    return {
      sidebar,
      device,
      user,
      loginOut,
      OFF,
      ON,
      setlaguase,
      ...toRefs(state),
      t
    }                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
  }
}
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    display: flex;
    align-items: center;
    height: 100%;
    float: left;
    padding: 0 15px;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;
    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .refresh{
    margin-top: 1px;
    padding: 0px;
    transition: 1s;
  }

  .breadcrumb-container {
    float: left;
  }

  .errLog-container {
    display: inline-block;
    vertical-align: top;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }
     .setrightmenu{
      display: flex;
      justify-content: center;
      align-items: center;
      height: 50px;
      cursor: pointer;
      .laguaes{
        margin-right: 15px;
        img{
          width: 24px;
        }
      }
     }
    .right-menu-item {
      display: flex;
      align-items: center;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      .avatar-wrapper {
        position: relative;
        bottom: 16px;
        margin-right: 20px;

        .user-avatar {
          cursor: pointer;
          width: 40px;
          height: 40px;
          border-radius: 40px;
          display: none;
        }
        span {
          // display: inline-block;
          height: 40px;
          line-height: 40px;
          margin-left: 10px;
          cursor: pointer;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
</style>
